import { connect } from 'react-redux';
import { getActiveListingPage } from '../../reduck/selectors';
import SegmentSwatches from '../SegmentSwatches/SegmentSwatches';
import { changeRegularFilter } from '../../reduck/listingPagePages.reduck';


const mapStateToProps = (state) => ({
  segmentsData: getActiveListingPage(state).filtersFromSearchLabs.find((filterObject) => filterObject.id === 'segment_id')
    .values
    .filter((valueObject) => valueObject.count !== '0')
    .map((valueObject) => ({
      ...valueObject,
      imgSrc: state.listingPage.staticData.ucmsHierarchy.segments.find(
        (segment) => segment.id === Number(valueObject.value)
      ).src
    })),
  disabled: state.listingPage.commonData.xhrStatus.pendingProductsRequest,
  mobile: state.listingPage.browser && state.listingPage.browser.device.deviceType === 'mobile'
});

const mapDispatchToProps = (dispatch) => ({
  onSwatchClick: (segmentId, removeSegmentFilter = false) => {
    if (removeSegmentFilter) {
      dispatch(changeRegularFilter('segment_id', undefined));
    } else {
      dispatch(changeRegularFilter('segment_id', [String(segmentId)]));
    }

  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SegmentSwatches);
